import { Center, Pagination, type PaginationProps } from '@mantine/core';

import classes from './Pagination.module.css';

interface PaginationWrapperProps extends PaginationProps {}

const MercuryPagination = ({ ...paginationProps }: PaginationWrapperProps) => {
  if (!paginationProps.total || paginationProps.total === 1) return null;

  return (
    <Center>
      <Pagination
        mt={25}
        boundaries={1}
        siblings={3}
        classNames={{
          control: classes.paginationControl,
        }}
        {...paginationProps}
      />
    </Center>
  );
};

export default MercuryPagination;
